import React, { Fragment } from "react";
import { Card, CardBody } from "reactstrap";
// import { objectExpression } from '@babel/types';
import { filesize } from "filesize";
import IntlMessages from "../../helpers/IntlMessages";
import Linkify from 'linkify-react';

const MessageCard = ({ sender, item, currentUserid, file, bucket, isTranslationNeeded, locale, isLoading }) => {
  const attachment = ({ content_url, bytes, name, content_type }) => {
    if (content_type && content_type.includes("image")) {
      return <img src={bucket + content_url} alt={name} className="preview-container" />;
    }
    return (
      <div>
        <i className="simple-icon-paper-clip" /> <i>{name}</i>
      </div>
    );
  };

  return (
    <Fragment>
      {!isTranslationNeeded || isTranslationNeeded === false ? (
        <Card className={`d-inline-block mb-3 float-${item.is_staff !== "true" ? "right" : "left"}`}
          style={{ backgroundColor: `${item.is_staff !== "true" ? "white" : "antiquewhite"}` }}
        >
          <CardBody>
            {!isLoading ?
              (
                <div>
                  <div>
                    <span className="text-extra-small text-muted">{item.created_at_date}</span>
                  </div>

                  <p className="mb-0 truncate list-item-heading"
                    style={{ fontWeight: "bold", fontSize: "small", color: "#28a745" }}
                  >
                    {sender && sender.name ? sender.name : ""}
                  </p>

                  <div className="chat-text-left">
                    <Linkify options={{ target: '_blank' }}>
                      <p className="mb-0 list-item-heading">{item.body}</p>
                    </Linkify>
                  </div>

                  {file && file[0] &&
                    (<div className="chat-text-right">
                      <a href={bucket + file[0].content_url} target="top">
                        {attachment(file[0])}
                      </a>
                    </div>)
                  }
                </div>
              ) : (
                <div className="loading" style={{ position: "inherit" }} />
              )
            }
          </CardBody>
        </Card>
      ) : (
        <Card className={`d-inline-block mb-3 float-${item.is_staff !== "true" ? "right" : "left"}`}
          style={{ backgroundColor: `${item.is_staff !== "true" ? "white" : "antiquewhite"}` }}
        >
          <CardBody>
            <div>
              <span className="text-extra-small text-muted">{item.created_at_date}</span>
            </div>

            <p className="mb-0 truncate list-item-heading"
              style={{ fontWeight: "bold", fontSize: "small", color: "#28a745" }}
            >
              {sender && sender.name ? sender.name : ""}
            </p>

            <div className="chat-text-left">
              {item.translations && Object.keys(item.translations) && Object.keys(item.translations).length ?
                (
                  <div>
                    <div>
                      <p className="mb-0 list-item-heading">{item.body}</p>
                      <div className="badge badge-secondary" style={{ fontSize: "12px" }}>
                        <IntlMessages id="request.message_translation_detect" /> : {item.detectedSourceLanguage}
                      </div>
                      <div className="badge badge-info" style={{ fontSize: "12px" }}>
                        <IntlMessages id="request.message_translation" /> : {locale}
                      </div>
                    </div>
                    <p>{item.translations[locale]}</p>
                  </div>
                ) : (
                  <p className="mb-0 list-item-heading">{item.body}</p>
                )
              }
            </div>
          </CardBody>
        </Card>
      )}
      <div className="clearfix" />
    </Fragment>
  );
};

export default MessageCard;
